import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { BrowserRouter, HashRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Router from './router';


export const queryClient = new QueryClient();

export default function Root(props) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename='/'>
        <Router />
      </BrowserRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
}
